import React, { useEffect, useState } from 'react';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  TableCell,
  TableRow,
  Snackbar
} from '@material-ui/core';
import { parsePrice } from '../../utils';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import { btnColor, userRole } from '../../GlobalState';
import { TWorkingBudget } from '../../types/WorkingBudgetList';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { deleteWorkingBudget } from '../../apicalls/WorkingBudgetList';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

type TProps = {
  row: TWorkingBudget;
  selectItems: number[];
  setSelectItems: any;
  searchWorkingBudget: () => void;
  setLoading: any;
  currentPage: number;
};

export const ItemTableRow: React.FC<TProps> = (props: TProps) => {
  const {
    row,
    selectItems,
    setSelectItems,
    searchWorkingBudget,
    setLoading,
    currentPage
  } = props;

  const [buttonColor] = useRecoilState(btnColor);
  const history: any = useHistory();
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [userPermission] = useRecoilState(userRole);
  const [errorMessage, setErrorMessage] = useState('');

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const check = (val: any) => {
    let arr = _.cloneDeep(selectItems);
    if (val.target.checked) {
      arr.push(row.working_budget_id);
    } else {
      arr = arr.filter(item => item != row.working_budget_id);
    }
    setSelectItems(arr);
  };

  const onClickRow = () => {
    history.push(`/working_budget?id=${row.working_budget_id}`, {
      currentPage: currentPage
    });
  };

  const handleClickOpenAlert = () => {
    if (userPermission !== 1) {
      setErrorMessage('削除の権限がありません。');
      setOpen(true);
    } else {
      setOpenAlert(true);
    }
  };

  const onClickDelete = () => {
    setLoading(true);
    deleteWorkingBudget(row.working_budget_id)
      .then(() => {
        searchWorkingBudget();
      })
      .finally(() => setLoading(false));
    setOpenAlert(false);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error'>
          {errorMessage}
        </Alert>
      </Snackbar>
      <StyledTableRow className='click_table_row' title='編集'>
        {/* チェックボックス */}
        <StyledTableCell align='center'>
          <CustomTooltip title={tooltipContents.selectDelete} placement='top'>
            <Checkbox
              checked={selectItems.some(i => i == row.working_budget_id)}
              onChange={check}
              style={{
                color: buttonColor
              }}
            />
          </CustomTooltip>
        </StyledTableCell>
        {/* 実行予算番号 */}
        <StyledTableCell align='left'>
          {row.working_budget_id
            ? String(row.working_budget_id).padStart(5, '0')
            : 0}
        </StyledTableCell>
        {/* 工事件名 */}
        <StyledTableCell onClick={onClickRow} align='left'>
          {row.construct_name}
        </StyledTableCell>
        {/* 見積合計額 */}
        <StyledTableCell onClick={onClickRow} align='right'>
          {parsePrice(row.estimate_total)}
        </StyledTableCell>
        {/* 見積原価合計額 */}
        <StyledTableCell onClick={onClickRow} align='right'>
          {parsePrice(row.estimate_cost_total)}
        </StyledTableCell>
        {/* 追加原価 */}
        <StyledTableCell onClick={onClickRow} align='right'>
          {parsePrice(row.additional_cost)}
        </StyledTableCell>
        {/* 最終粗利金額 */}
        <StyledTableCell onClick={onClickRow} align='right'>
          {parsePrice(row.final_gross_profit)}
        </StyledTableCell>
        {/* 最終粗利率 */}
        <StyledTableCell align='right'>
          {parsePrice(row.final_gross_profit_margin, '%')}
        </StyledTableCell>
        {/* 発注総額 */}
        <StyledTableCell onClick={onClickRow} align='right'>
          {parsePrice(row.order_total)}
        </StyledTableCell>
        {/* 削除ボタン */}
        <StyledTableCell align='center'>
          {userPermission === 1 && (
            <Button
              style={{ backgroundColor: buttonColor }}
              variant='contained'
              color='primary'
              startIcon={<DeleteIcon />}
              onClick={handleClickOpenAlert}
            >
              削除
            </Button>
          )}
        </StyledTableCell>
      </StyledTableRow>
      <Dialog
        open={openAlert}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{'削除しますか？'}</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpenAlert(false)} color='primary'>
            キャンセル
          </Button>
          <Button onClick={onClickDelete} color='primary' autoFocus>
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
